import { useState } from "react";
import { toFa, addDays, productDay, formatJalali, onVacation } from "@soheil/core";
import { useStore } from "../data/store";
import { useEntitlement } from "../data/entitlement";
import { useToast } from "./Toast";
import { rawInitData } from "../platform/telegram";

/**
 * ابزارهای ستارهٔ بی‌نهایت: حالت تعطیلات و خروجی گرفتن از داده‌ها.
 *
 * برای کاربر رایگان اصلاً نمایش داده نمی‌شود. دکمهٔ قفل‌شده‌ای که کاری نمی‌کند،
 * فقط صفحه را شلوغ می‌کند؛ جای فروختن، صفحهٔ «ستارهٔ بی‌نهایت» است.
 */

const SPANS = [7, 14, 30];

export function PlusTools() {
  const { state, dispatch, today } = useStore();
  const ent = useEntitlement();
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!ent.plus) return null;

  const from = state.settings.vacationFrom;
  const until = state.settings.vacationUntil;
  const active = onVacation(today, { vacationFrom: from, vacationUntil: until });

  const startVacation = (days: number) => {
    const end = addDays(productDay(), days - 1);
    dispatch({
      type: "setSettings",
      patch: { vacationFrom: productDay(), vacationUntil: end, updatedAt: Date.now() },
    });
    toast(`حالت تعطیلات تا ${formatJalali(end)} روشن شد`);
  };

  const stopVacation = () => {
    dispatch({
      type: "setSettings",
      patch: { vacationFrom: undefined, vacationUntil: undefined, updatedAt: Date.now() },
    });
    toast("حالت تعطیلات خاموش شد");
  };

  const exportData = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await fetch(`${location.origin}/api/export`, {
        headers: { "X-Telegram-Init-Data": rawInitData() },
      });
      if (!r.ok) {
        toast("گرفتن خروجی نشد");
        return;
      }
      const blob = await r.blob();
      // در وب‌ویو تلگرام دانلود مستقیم همیشه کار نمی‌کند؛ اگر نشد، ربات
      // همان فایل را با /export می‌فرستد و آنجا مطمئناً می‌رسد.
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `setare-soheil-${today}.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      toast("فایل ساخته شد — اگر دانلود نشد، در ربات /export را بزن");
    } catch {
      toast("اینترنت وصل نیست");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="block">
      <h2 className="sect">ابزارهای ستارهٔ بی‌نهایت</h2>

      <div className="ptool">
        <div className="ptool-head">
          <b>🏖 حالت تعطیلات</b>
          <span>{active ? `روشن تا ${formatJalali(until!)}` : "خاموش"}</span>
        </div>
        <p className="hint">
          {active
            ? "تا آن روز، غیبت‌ها زنجیره‌ات را نمی‌شکنند. سفر خوش."
            : "می‌روی سفر؟ روشنش کن تا زنجیره‌ات سالم بماند."}
        </p>
        {active ? (
          <button className="link" onClick={stopVacation}>خاموش کن</button>
        ) : (
          <div className="picker">
            {SPANS.map((d) => (
              <button key={d} onClick={() => startVacation(d)}>{toFa(d)} روز</button>
            ))}
          </div>
        )}
      </div>

      <div className="ptool">
        <div className="ptool-head">
          <b>📦 خروجی داده‌ها</b>
        </div>
        <p className="hint">همهٔ عادت‌ها، کارها، ستاره‌ها و مرورها در یک فایل.</p>
        <button className="link" disabled={busy} onClick={() => void exportData()}>
          {busy ? "در حال آماده کردن…" : "گرفتن فایل"}
        </button>
      </div>
    </section>
  );
}
